import { AxiosPromise, AxiosStatic } from "axios";
import {
  BankVerificationLinkTokenResponseDto,
  CountryISO,
  PlaidCoverageResponseDto,
  PlaidLinkTokenResponseDto,
  VerifyBankAccountRequestDto,
  VerifyBankAccountResponseDto,
  PaymentInitiationLinkTokenRequestDto,
  PaymentInitiationLinkTokenResponseDto,
  CreateBankAccountFromPlaidRequestDto,
  CreateBankAccountFromPlaidResponseDto,
  IdvScanStartBody,
  IdvScanStartResponse,
} from "../types";

export const checkPlaidCoverage =
  (serverURL: string, axios: AxiosStatic) =>
  (country: CountryISO): AxiosPromise<PlaidCoverageResponseDto> => {
    return axios.get(`${serverURL}/plaid/coverage?country=${country}`, {
      withCredentials: true,
    });
  };

export const getBankVerificationLinkToken =
  (serverURL: string, axios: AxiosStatic) =>
  (params?: {
    platform?: "iOS" | "Android";
    androidPackageName?: string;
  }): AxiosPromise<BankVerificationLinkTokenResponseDto> => {
    return axios.post(
      `${serverURL}/plaid/bank-verification/link-token`,
      { androidPackageName: params?.androidPackageName },
      {
        withCredentials: true,
        headers: params?.platform
          ? { "x-application-platform": params.platform }
          : {},
      }
    );
  };

export const verifyBankAccount =
  (serverURL: string, axios: AxiosStatic) =>
  (
    data: VerifyBankAccountRequestDto
  ): AxiosPromise<VerifyBankAccountResponseDto> => {
    return axios.post(`${serverURL}/plaid/verify-bank-account`, data, {
      withCredentials: true,
    });
  };

export const getPaymentInitiationLinkToken =
  (serverURL: string, axios: AxiosStatic) =>
  (
    data: PaymentInitiationLinkTokenRequestDto
  ): AxiosPromise<PaymentInitiationLinkTokenResponseDto> => {
    return axios.post(
      `${serverURL}/plaid/payment-initiation/link-token`,
      data,
      {
        withCredentials: true,
      }
    );
  };

export const getIdvLinkToken =
  (serverURL: string, axios: AxiosStatic) =>
  (): AxiosPromise<PlaidLinkTokenResponseDto> => {
    return axios.post(
      `${serverURL}/plaid/identity-verification/link-token`,
      {},
      {
        withCredentials: true,
      }
    );
  };

export const startIdvScan =
  (serverURL: string, axios: AxiosStatic) =>
  (body: IdvScanStartBody): AxiosPromise<IdvScanStartResponse> => {
    return axios.post(
      `${serverURL}/plaid/identity-verification/link-token`,
      body,
      {
        withCredentials: true,
      }
    );
  };

export const createBankAccountFromPlaid =
  (serverURL: string, axios: Pick<AxiosStatic, "post">) =>
  (
    data: CreateBankAccountFromPlaidRequestDto
  ): AxiosPromise<CreateBankAccountFromPlaidResponseDto> => {
    return axios.post(
      `${serverURL}/plaid/bank-verification/bank-accounts`,
      data,
      {
        withCredentials: true,
      }
    );
  };
